/**
 * Add handling for touch devices to view secondary product card image
 */
function initProductCardMobileSecondary() {
	const nextBtns = document.querySelectorAll('.js-show-next-btn');
	const prevBtns = document.querySelectorAll('.js-show-prev-btn');

	function loopProductCardImages(target) {
		if (!target.classList.contains('show-secondary')) {
			target.classList.remove('show-primary');
			target.classList.add('show-secondary');
		} else {
			target.classList.add('show-primary');
			target.classList.remove('show-secondary');
		}
	}

	nextBtns.forEach((nextBtn) => {
		nextBtn.addEventListener('click', function() {
			const parentFig = this.closest('.product-card__figure');
			loopProductCardImages(parentFig);
			//parentFig.classList.remove('show-primary');
			//parentFig.classList.add('show-secondary');
		})
	})

	prevBtns.forEach((prevBtn) => {
		prevBtn.addEventListener('click', function() {
			const parentFig = this.closest('.product-card__figure');
			loopProductCardImages(parentFig);
			//parentFig.classList.add('show-primary');
			//parentFig.classList.remove('show-secondary');
		})
	})
}

document.addEventListener('DOMContentLoaded', function() {
	initProductCardMobileSecondary();
})